module.exports = __webpack_public_path__ + "static/img/apple@2x.0b266db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dominos-assets/apple@2x.png
// module id = QsmR
// module chunks = 0